// Basic
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';

// Modules
import { MaterialModule } from '@app/material.module';

// Components
import { RecipeNotAllowedDialogComponent } from './recipe-not-allowed-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MaterialModule,
  ],
  declarations: [RecipeNotAllowedDialogComponent],
  exports: [RecipeNotAllowedDialogComponent],
  entryComponents: [RecipeNotAllowedDialogComponent]
})
export class RecipeNotAllowedDialogModule { }
